import React, { useState } from "react";
import { 
  MousePointer, 
  TrendingUp, 
  Minus, 
  Square, 
  Sliders, 
  Type, 
  Trash2, 
  Plus, 
  Palette, 
  Check 
} from "lucide-react";

export default function DrawingToolbar({
  activeTool,
  onSelectTool,
  onClearAll,
  drawingCount,
  drawColor,
  onChangeDrawColor,
}) {
  const [isColorMenuOpen, setIsColorMenuOpen] = useState(false);
  const COLORS = ["#38bdf8", "#10b981", "#ef4444", "#f59e0b", "#c084fc", "#f43f5e", "#ffffff"];

  const tools = [
    { id: "cursor", label: "Con trỏ / Soi giá (Cursor)", icon: MousePointer },
    { id: "trendline", label: "Đường xu hướng (Trendline)", icon: TrendingUp },
    { id: "horizontal", label: "Đường ngang Hỗ trợ / Kháng cự", icon: Minus },
    { id: "rectangle", label: "Hộp vùng giá (Supply/Demand Box)", icon: Square },
    { id: "fibonacci", label: "Thước thoái lui Fibonacci", icon: Sliders },
    { id: "text", label: "Ghi chú phân tích (Text)", icon: Type },
  ];

  return (
    <div className="flex flex-col items-center py-1.5 sm:py-2 px-1 sm:px-1.5 bg-slate-900/95 border-r border-slate-800 text-slate-400 gap-1 sm:gap-1.5 z-20 select-none shadow-lg shrink-0">
      {/* Drawing Tools */}
      {tools.map((t) => {
        const Icon = t.icon;
        const isActive = activeTool === t.id;

        return (
          <button
            key={t.id}
            onClick={() => onSelectTool(t.id)}
            className={`p-1.5 sm:p-2 rounded-lg sm:rounded-xl transition cursor-pointer relative group ${
              isActive
                ? "bg-cyan-500 text-slate-950 font-bold shadow-md shadow-cyan-500/20"
                : "hover:bg-slate-800 hover:text-slate-200"
            }`}
            title={t.label}
          >
            <Icon className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
            <span className="absolute left-10 ml-2 px-2.5 py-1 bg-slate-950 text-slate-200 text-xs font-semibold rounded-lg shadow-xl border border-slate-800 whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition z-50">
              {t.label}
            </span>
          </button>
        );
      })}

      <div className="w-5 sm:w-6 h-px bg-slate-800 my-0.5" />

      {/* Color Palette Quick Chooser */}
      <div className="relative">
        <button
          onClick={() => setIsColorMenuOpen(!isColorMenuOpen)}
          className="p-1.5 sm:p-2 rounded-lg sm:rounded-xl hover:bg-slate-800 text-slate-300 transition cursor-pointer relative group"
          title="Chọn màu nét vẽ"
        >
          <div className="w-3.5 h-3.5 sm:w-4 sm:h-4 rounded-full border border-slate-600 shadow-sm" style={{ backgroundColor: drawColor }} />
          <span className="absolute left-10 ml-2 px-2.5 py-1 bg-slate-950 text-slate-200 text-xs font-semibold rounded-lg shadow-xl border border-slate-800 whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition z-50">
            Màu vẽ: {drawColor}
          </span>
        </button>

        {isColorMenuOpen && (
          <div className="absolute left-10 top-0 bg-slate-900 border border-slate-700 rounded-xl p-2 shadow-2xl flex flex-col gap-1.5 z-50 animate-fadeIn">
            {COLORS.map((c) => (
              <button
                key={c}
                onClick={() => {
                  onChangeDrawColor(c);
                  setIsColorMenuOpen(false);
                }}
                className="w-5 h-5 rounded-full border border-slate-700 hover:scale-110 transition cursor-pointer flex items-center justify-center"
                style={{ backgroundColor: c }}
              >
                {drawColor === c && <Check className="w-3 h-3 text-slate-950 stroke-[3]" />}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Delete / Clear All Drawings */}
      <button
        onClick={onClearAll}
        disabled={drawingCount === 0}
        className={`p-1.5 sm:p-2 rounded-lg sm:rounded-xl transition cursor-pointer relative group mt-auto ${
          drawingCount > 0
            ? "hover:bg-rose-500/20 text-slate-400 hover:text-rose-400"
            : "opacity-30 cursor-not-allowed"
        }`}
        title={`Xóa tất cả (${drawingCount} nét vẽ)`}
      >
        <Trash2 className="w-3.5 h-3.5 sm:w-4 sm:h-4" />
        <span className="absolute left-10 ml-2 px-2.5 py-1 bg-slate-950 text-slate-200 text-xs font-semibold rounded-lg shadow-xl border border-slate-800 whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition z-50">
          🧹 Xóa toàn bộ ({drawingCount} nét vẽ)
        </span>
      </button>
    </div>
  );
}
